import * as React from "react";
import * as main from "../../main.module.scss";
import * as screen1 from "./style.module.scss";
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
import { WebDate } from "../../../../WebDate";
export const Screen1 = ({ id, dateText, sravni }) => {

  return (
    <header className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel noLink={sravni}/>
        <div className={screen1.content}>
          <div className={screen1.info}>
            <h1>Интеллектуальный марафон:<span>приведи свой мозг в тонус!</span></h1>
            <p className={screen1.sub}>Бесплатный онлайн-интенсив личного развития</p>

            <div className={screen1.dates}>
              <WebDate id={id} dateText={dateText}/>
            </div>

            <a className={main.btn} href="#order">зарегистрироваться</a>
            <div className={screen1.bonus}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94 94"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="47" y1="93.89" x2="47" y2="-.11" gradientTransform="matrix(1 0 0 -1 0 93.89)"><stop offset="0" stopColor="#ff639b"/><stop offset="1" stopColor="#cf024c" stopOpacity=".78"/></linearGradient><circle cx="47" cy="47" r="47" fill="url(#a)"/><path d="M54.1 37.3h18.8c.8 0 1.5.6 1.5 1.5v5.1c0 .8-.6 1.5-1.5 1.5H54.1v-8.1zm-33.6 0h19v8h-19c-.8 0-1.5-.6-1.5-1.5v-5.1c0-.8.6-1.4 1.5-1.4zm22.2 35.1V36.9c0-.8.6-1.5 1.5-1.5h5.1c.8 0 1.5.6 1.5 1.5v35.5c0 .8-.6 1.5-1.5 1.5h-5.1c-.9 0-1.5-.6-1.5-1.5zm28.1-23.9v20.3c0 1.9-1.7 3.6-3.8 3.6H54.1V48.5h16.7zm-31.3 0v23.9H26.4c-2.1 0-3.6-1.7-3.6-3.6V48.5h16.7zm2.8-14.6c-8.3 1.7-15.9.4-22.4-2.5l1.9-1.9c0-.8 0-1.9-.2-2.8 3.5 2.4 11.6 6.8 20.7 7.2zm9.1 0c8.3 1.7 15.9.4 22.2-2.5l-1.9-1.9c0-.8.2-1.9.2-2.8-3.6 2.4-11.6 6.8-20.5 7.2zm9.9-15.8c2.8 2.8 2.8 7.4 0 10.2s-9.5 2.8-13.5 3.2c.6-3.8.4-10.6 3.2-13.3 2.9-2.9 7.3-2.9 10.3-.1zm-8.9 8.8c2.5-.2 5.1-.6 5.9-1.5 1.3-1.3 1.3-3.4 0-4.4-1.3-1.3-3.2-1.3-4.4 0-.8.7-1.3 3.4-1.5 5.9zm-20.1-8.8c-3 2.8-3 7.4 0 10.2 2.5 2.8 9.3 2.8 13.3 3.2-.4-3.8-.4-10.6-3.2-13.3-2.7-2.9-7.3-2.9-10.1-.1zm8.9 8.8c-2.5-.2-5.3-.6-6.1-1.5-1.3-1.3-1.3-3.4 0-4.4 1.3-1.3 3.4-1.3 4.7 0 .6.7 1 3.4 1.4 5.9z" fillRule="evenodd" clipRule="evenodd" fill="#fff"/></svg>
              <div>
                <p>20&nbsp;нейроупражнений для&nbsp;развития мозга</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
